import { lazy, Suspense } from "react";
import { useAuth } from "../../../hooks/useAuth";
import { useLeagueWeekRecap } from "../hooks/useLeagueWeekRecap";
import { useSuppressCelebrations } from "../../gamification/utils/celebrationGate";

// Lazy: o cartão abre uma vez por semana; fora do entry (17/09).
const LeagueWeekRecapModal = lazy(() =>
  import("./LeagueWeekRecapModal").then((m) => ({ default: m.LeagueWeekRecapModal })),
);

/**
 * Watcher global do fechamento da liga — irmão do `BadgeUnlockWatcher`.
 *
 * Montado uma única vez no `AppFrame`. Sem auth, é no-op.
 *
 * ⚠️ Sucessor do `LeaguePromotionWatcher`, que perguntava `isTierUp` e por isso
 * era **mudo para quem ficou no meio ou caiu de liga** — a maioria de qualquer
 * sala, toda semana. O nome antigo passou a descrever metade do que a peça faz,
 * e nome errado é dívida: quem procurasse "por que não avisou que eu caí" não
 * encontraria o arquivo.
 */
export function LeagueWeekRecapWatcher() {
  const { user, profile } = useAuth();

  const { recap, dismiss } = useLeagueWeekRecap(user?.uid ?? null);

  /*
   * Duas celebrações automáticas na mesma tela é uma a mais. A virada da liga é
   * semanal e chega primeiro; a conquista espera a fila drenar depois.
   *
   * O bloqueio é declarado enquanto o cartão está ABERTO — o hook já respeita o
   * gate na outra direção, então quem chegar primeiro fica, sem deadlock.
   */
  useSuppressCelebrations(!!recap, "league-recap");

  if (!recap || !user) return null;

  return (
    <Suspense fallback={null}>
    <LeagueWeekRecapModal
      recap={recap}
      username={profile?.username ?? profile?.displayName ?? "leitor"}
      themeId={profile?.themeId ?? profile?.themePreference}
      onClose={dismiss}
    />
    </Suspense>
  );
}
